<template>
  <div class="event" style="width:100%">
    <div class="user-header">
        <button @click="back" type="button" class="button primary block">
          <svg width="42px" height="42px" viewBox="0 0 42 42" xml:space="preserve"> <polygon fill-rule="evenodd" points="27.066,1 7,21.068 26.568,40.637 31.502,35.704 16.865,21.068 32,5.933 "/> </svg>
          Geri Dön</button>
        <div>
          <p>{{ $store.getters['getClientMeta'].name }}</p>
          <h3 class="line-title">{{ activeTicket.ticket_id }} Mesaj Detayı</h3>
        </div>
    </div>
    <div class="user-content-inc fluid">
        <div class="panel message-detail">
          <div class="title" v-if="!isMobile">#{{ activeTicket.ticket_id }} Talep Detayları </div>
          <div class="content">
              <div class="message">
                  <div class="item" v-for="message in activeTicket.detail" :key="message" :class="message.side_position">
                    <div class="box">
                      <h5>{{ $t(message.creator_type) }}</h5>
                      <p>{{ message.message }}</p>
                      <small>{{ $moment(message.created_at).format('MM/DD HH:MM:SS') }}</small>
                    </div>
                  </div>
              </div>
              <form class="row message_form" @submit.prevent="send('')" v-if="activeTicket.status != 'completed'">
                <div class="col col-5">
                  <input type="text" v-model="form.message" placeholder="Bir şeyler yazın.">
                </div>
                <div class="col col-3 send">
                  <ButtonLoader class="primary block" :loader="btnLoading" :text="'Mesajı Gönderin'" />
                </div>
                <div class="col col-4 finish">
                  <button @click="send('completed')" type="button" class="button secondary block">Mesajlaşmayı Tamamla</button>
                </div>
              </form>
          </div>
        </div>
    </div>
  </div>
</template> 
<style>
  .flex .button{
    width: 100px;
    height: 40px;
    margin-bottom: 5px
  }
</style>
<script>
  import Header from '../../Common/User/Header'
  export default{
    props:['activeTicket'],
    data(){
      return{
        form:{
          id: this.activeTicket.ticket_id,
          message: null,
        },
        btnLoading: false,
      }
    },
    components:{
      Header
    },
    methods:{
      send(action){
          this.btnLoading = true;
          if(!_.isUndefined(action) && !_.isEmpty(action)){
            this.form.message = 'completed';
          }
          axios.patch('/user/tickets/' + this.activeTicket.ticket_id, { ...this.form })
          .then((response)=>{
            this.$store.dispatch('alert/message', { type: 'success', msg: response.data.message })
            this.back();
          })
          .catch(() => {})
          .finally(() => {
            this.btnLoading = false;
          });
      },
      back(){
        this.$emit('activeTicket', {});
        this.$router.replace({ query: { ticket: null}});
      }
    }
  }
</script>